import React from 'react';
import { Fab, AddIcon } from './style';

const FloatingButton = (props) => {
  return (
    <Fab {...props}>
      <AddIcon />
    </Fab>
  );
};

export default FloatingButton;
